function removeFromStart(string: string, value: string) {
  if (string.startsWith(value)) {
    return string.substr(value.length);
  } else {
    return string;
  }
}

function declination(words: string[], value: number): string {
  const num = Math.abs(value) % 100;
  const sum = num % 10;

  if (num > 10 && num < 20) { return words[2]; }
  if (sum > 1 && sum < 5) { return words[1]; }
  if (sum === 1) { return words[0]; }
  return words[2];
}


export const StringUtils = {
  removeFromStart: removeFromStart,
  declination: declination
}
